import type { ReactChild, ReactNode, ReactText } from 'react';
import type { TextProps } from 'react-native';

export type TagLabelProps = {
  readonly testID?: string;
} & GarnishProps &
  TagLabelChildren &
  TextProps;

export type TagLabelChildren = {
  readonly children: ReactChild | ReactText;
};

export type BoxProps = {
  readonly children: ReactNode;
  readonly testID?: string;
} & Required<GarnishProps>;

export type TextParentProps = {
  readonly children: ReactNode;
} & Required<GarnishProps> &
  TextProps;

export type GarnishProps = {
  readonly size?: SizeTypes;
  readonly palette?: PaletteTypes;
};

export type SizeTypes = Required<keyof typeof TagLabelSize>;
export type PaletteTypes = Required<keyof typeof TagLabelPalette>;

export const TagLabelSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const TagLabelPalette = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
};
